var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomNavCommunityTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 14C27 21.1797 21.1797 27 14 27H3.4123C2.66161 27 2.28627 27 2.07537 26.8486C1.8837 26.7111 1.77243 26.5225 1.74461 26.2883C1.714 26.0305 1.9094 25.6765 2.3002 24.9684C2.41206 24.7658 2.4965 24.5893 2.55918 24.4241C2.92161 23.4687 2.96472 23.1612 2.87892 22.143C2.8295 21.5565 2.44671 20.3594 1.68113 17.9651L1.68111 17.965C1.2875 16.7341 1 15.367 1 14C1 6.8203 6.8203 1 14 1C21.1797 1 27 6.8203 27 14ZM6.9222 11.1112C6.9222 10.3932 7.50423 9.81118 8.2222 9.81118H19.7778C20.4957 9.81118 21.0778 10.3932 21.0778 11.1112C21.0778 11.8292 20.4957 12.4112 19.7778 12.4112H8.2222C7.50423 12.4112 6.9222 11.8292 6.9222 11.1112ZM6.9222 16.8889C6.9222 16.1709 7.50423 15.5889 8.2222 15.5889H14C14.718 15.5889 15.3 16.1709 15.3 16.8889C15.3 17.6069 14.718 18.1889 14 18.1889H8.2222C7.50423 18.1889 6.9222 17.6069 6.9222 16.8889Z",
    fill: "#004FEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomNavCommunityTrue);
export default __webpack_public_path__ + "static/media/bottom_nav_community_true.29e165551f987406dafc579958be4938.svg";
export { ForwardRef as ReactComponent };